// Not Found Page Component - Centralized 404 page
import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getFirstAvailableRoute, isLogin } from '../../utils/permissions';

/**
 * NotFoundPage - Shown when user navigates to a route that doesn't exist
 * Uses Ant Design's Result component for consistent UI
 */
const NotFoundPage = () => {
  const navigate = useNavigate();
  const loggedIn = isLogin();
  const firstRoute = getFirstAvailableRoute();
  
  // Determine where to redirect based on login status
  const redirectPath = loggedIn ? (firstRoute?.path || '/') : '/login';
  const buttonLabel = loggedIn ? (firstRoute?.label || 'Home') : 'Login';

  const handleClick = () => {
    navigate(redirectPath);
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button type="primary" onClick={handleClick}>
            Go to {buttonLabel}
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
